/* @flow */

import { Map, List } from 'immutable';

import { TITLES_LIST_REQUEST, TITLES_LIST_SUCCESS, TITLES_LIST_FAILURE } from './action';

const initialState = Map({
  type: '', loading: false, payload: Map({}), messages: List([]),
});

export default function reducer(state = initialState, action): any {
  const { type } = action;

  if (type === TITLES_LIST_REQUEST) {
    return state.updateIn(['type'], () => type).updateIn(['loading'], () => true);
  }

  if (type === TITLES_LIST_SUCCESS) {
    const { payload } = action;
    return state
      .updateIn(['type'], () => type)
      .updateIn(['loading'], () => false)
      .updateIn(['messages'], () => List([]))
      .setIn(['payload'], Map(payload));
  }

  if (type === TITLES_LIST_FAILURE) {
    const { payload } = action;
    return state.updateIn(['type'], () => type).updateIn(['loading'], () => false).setIn(['messages'], List(payload));
  }

  return state;
}
